// extracted by mini-css-extract-plugin
export default {"addCard":"ResearchSavedSearches_addCard__Nw4eg"};